"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CORE_REMOTES_SETTINGS = void 0;
var settingsUtils_1 = require("./settingsUtils");
var types_1 = require("./types");
var settings = (0, settingsUtils_1.addFixSettingsIn)({
    type: types_1.MFE_TYPES.core,
    skipImportingInCMS: false,
}, {
    tpdRemotesImporter: {
        __mfeName__: "tpdRemotesImporter",
        devClientPort: 2999,
        devServerPort: 2999,
    },
    richText: {
        __mfeName__: "richText",
        devClientPort: 3002,
        devServerPort: 3002,
    },
    tpdShortText: {
        __mfeName__: "tpdShortText",
        devClientPort: 3003,
        devServerPort: 3003,
    },
    tpdCta: {
        __mfeName__: "tpdCta",
        devClientPort: 3004,
        devServerPort: 3004,
    },
    tpdImage: {
        __mfeName__: "tpdImage",
        devClientPort: 3005,
        devServerPort: 3005,
    },
    tpdOptionSelection: {
        __mfeName__: "tpdOptionSelection",
        devClientPort: 3011,
        devServerPort: 3011,
    },
    tpdItem: {
        __mfeName__: "tpdItem",
        devClientPort: 3012,
        devServerPort: 3012,
    },
    tpdNumber: {
        __mfeName__: "tpdNumber",
        devClientPort: 3036,
        devServerPort: 3036,
    },
});
// ******* EXCEPTIONS
settings.tpdRemotesImporter.skipImportingInCMS = true;
exports.CORE_REMOTES_SETTINGS = settings;
